import { type ReactNode } from "react"
import * as Collapsible from "@radix-ui/react-collapsible"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"

type CollapsibleSectionProps = {
  title: string
  icon?: ReactNode
  children: ReactNode
  defaultOpen?: boolean
  className?: string
}

export function CollapsibleSection({
  title,
  icon,
  children,
  defaultOpen = false,
  className,
}: CollapsibleSectionProps) {
  return (
    <Collapsible.Root
      defaultOpen={defaultOpen}
      className={cn("w-full", className)}
    >
      <Collapsible.Trigger className="flex w-full items-center justify-between py-1 text-left leading-6 transition-all hover:no-underline [&[data-state=open]>svg]:rotate-180">
        <span className="flex items-center gap-3">
          {icon}
          <span>{title}</span>
        </span>
        <ChevronDown
          size={16}
          strokeWidth={2}
          className="shrink-0 opacity-60 transition-transform duration-200"
          aria-hidden="true"
        />
      </Collapsible.Trigger>
      <Collapsible.Content className="overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down">
        <div className="py-2 ps-7">{children}</div>
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
